import type { CalendarEvent } from 'types';
import type { AppState, AppAction } from '../appReducerTypes';

const sortCalendarEvents = (events: CalendarEvent[]): CalendarEvent[] =>
  [...events].sort((a, b) => {
    const startA = new Date(a.start).getTime();
    const startB = new Date(b.start).getTime();
    if (Number.isNaN(startA) || Number.isNaN(startB)) {
      return Number.isNaN(startA) ? 1 : -1;
    }
    return startA - startB;
  });

export function calendarReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'SET_CALENDAR_EVENTS':
      return {
        ...state,
        calendarEvents: sortCalendarEvents(action.payload),
      };
    case 'ADD_CALENDAR_EVENT':
      return {
        ...state,
        calendarEvents: sortCalendarEvents([...state.calendarEvents, action.payload]),
      };
    case 'UPDATE_CALENDAR_EVENT':
      return {
        ...state,
        calendarEvents: sortCalendarEvents(
          state.calendarEvents.map((event) =>
            event.id === action.payload.id ? action.payload : event
          )
        ),
      };
    case 'DELETE_CALENDAR_EVENT':
      return {
        ...state,
        calendarEvents: state.calendarEvents.filter((event) => event.id !== action.payload),
      };
    case 'SET_CALENDAR_SUGGESTIONS':
      return { ...state, calendarSuggestions: action.payload };
    default:
      return state;
  }
}
